import styled from '@emotion/styled';
import LoadingIcon from '@/public/icons/record/loading.svg';

const TitleLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 180px;
`;

const StyledFilter = styled.div<{
  colorSet: { color: string; background: string; borderColor: string };
}>`
  color: ${({ colorSet }) => colorSet.color};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  text-transform: uppercase;
  width: fit-content;
  padding: 2px 8px;
  border-radius: 4px;
  background: ${({ colorSet }) => colorSet.background};
  border: 1px solid ${({ colorSet }) => colorSet.borderColor};
  white-space: pre;
  display: flex;
  align-items: center;
`;

const TypeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;

/** 실패 라벨 — 모바일 목록의 「업로드 실패」 배지와 같은 모양 (PORTAL-12583) */
const FailureBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  width: fit-content;
  padding: 2px 8px 2px 4px;
  border-radius: 4px;
  border: 1px solid #fbb9bf;
  background-color: #fef1f2;
  color: #f55060;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  white-space: pre;
`;

const CommentLayout = styled.div`
  display: flex;
  color: var(--dk-text-secondary, #888d96);
  gap: 12px;
  font-size: 14px;
`;

const StyledTitle = styled.div<{ isRead?: boolean }>`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  transition: max-width 0.3s;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  user-select: text;
  color: ${({ isRead }) => (isRead ? 'var(--dk-text-secondary, #888D96)' : 'var(--dk-text, #000)')};
`;

// 제목 아래 회의 정보 라인 (미팅 이름 | 회의 일시) — 회의록 리스트 전용
const MetaLine = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: var(--dk-text-secondary, #888d96);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const SpinningIcon = styled(LoadingIcon)`
  animation: spin 1s linear infinite;
  margin-left: -4px;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export {
  TitleLayout,
  TypeRow,
  FailureBadge,
  StyledFilter,
  StyledTitle,
  CommentLayout,
  MetaLine,
  SpinningIcon,
};
